import * as graphql from 'generated/graphql';
import Spinner from 'packages/kakapo-ui-kit/components/common/Spinner';
import Conversation from './components/Conversation';

export default function ConversationHOC(props: {
	conversationID: string;
	onCompleted?: () => void;
	userID?: string;
	returnUrl?: string;
}) {
	const { data, loading } = graphql.useConversationQuery({
		variables: {
			id: props.conversationID,
		},
		onCompleted: () => {
			props.onCompleted?.();
		},
	});

	if (data) {
		return (
			<Conversation
				returnUrl={props.returnUrl}
				conversation={data.conversation as graphql.Conversation}
			/>
		);
	}

	if (loading) {
		return <Spinner isLoading size="18px" />;
	}

	return null;
}
